import { REDESIGN_REQUEST_STATUSES } from '../constants';

export default class RedesignRequest {
  static defaultProps = {
    designId: '',
    spaceId: '',
    feedbackItems: [],
    whRedesignRequestId: null
  };

  static buildRedesignRequestKey = ({ spaceId, designId, whRedesignRequestId }) => {
    if (whRedesignRequestId) {
      return whRedesignRequestId;
    }
    if (spaceId && designId) {
      return `space-${spaceId}-design-${designId}`;
    }
    return '';
  }

  constructor (overrides) {
    this.fields = { ...RedesignRequest.defaultProps, ...overrides };
  }

  status () { return this.fields.status; }

  spaceId () { return this.fields.spaceId; }

  designId () { return this.fields.designId; }

  whRedesignRequestId () { return this.fields.whRedesignRequestId; }

  isStatusPending () {
    return this.status() === REDESIGN_REQUEST_STATUSES.PENDING;
  }

  id () {
    return RedesignRequest.buildRedesignRequestKey({
      spaceId: this.spaceId(),
      designId: this.designId(),
      whRedesignRequestId: this.whRedesignRequestId()
    });
  }

  feedbackItems () { return this.fields.feedbackItems; }

  convertToWarehouseRedesignRequest () {
    return {
      styleboard_id: this.spaceId(),
      design_id: this.designId(),
      status: this.status()
    };
  }

  makeCopy (overrides) {
    return new RedesignRequest({ ...this.fields, ...overrides });
  }
}
